<template>
    <v-card>
        <v-form ref="form">
            <v-btn
                icon
                style="margin-left: 97%;position: absolute;z-index: 1"
                @click="hiddenDialog"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ classStuMsg.className }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row
                            class="flex-child"
                        >
                            <v-col
                                cols="12"
                            >
                                <v-container fluid>
                                    <v-row align="center" v-for="(item,index) in allStudentMsg" :key="allStudentMsg.id">
                                        <v-col cols="3" md="1" sm="3" xs="3">
                                            <v-text-field
                                                :rules="rules.required"
                                                :label="$vuetify.lang.t('$vuetify.custom.student.name')+'*'"
                                                v-model="item.name"
                                                readonly
                                            ></v-text-field>
                                        </v-col>
                                        <!--<v-col cols="3" md="1" sm="3" xs="3">
                                            <v-radio-group v-model="item.gender" row>
                                                <v-radio :label="$vuetify.lang.t('$vuetify.custom.student.man')"
                                                         :value="0"></v-radio>
                                                <v-radio :label="$vuetify.lang.t('$vuetify.custom.student.women')"
                                                         :value="1"></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col cols="3" md="1" sm="3" xs="3">
                                            <v-text-field
                                                :label="$vuetify.lang.t('$vuetify.custom.student.age')+'*'"
                                                v-model="item.age"
                                            ></v-text-field>
                                        </v-col>-->
                                        <v-col cols="3" md="3" sm="3" xs="3">
                                            <v-text-field
                                                :label="$vuetify.lang.t('$vuetify.custom.student.idCard')+'*'"
                                                :rules="rules.idCard"
                                                v-model="item.idCard"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="3" md="2" sm="3" xs="3">
                                            <v-text-field
                                                :label="$vuetify.lang.t('$vuetify.custom.student.icePerson')+'*'"
                                                v-model="item.emergencyPerson"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="3" md="2" sm="3" xs="3">
                                            <v-text-field
                                                :label="$vuetify.lang.t('$vuetify.custom.student.iceCall')+'*'"
                                                v-model="item.emergencyCall"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="3" md="2" sm="3" xs="3">
                                            <el-select v-model="item.schoolId" filterable
                                                       placeholder="请选择学校">
                                                <el-option
                                                    v-for="item in schoolItems"
                                                    :key="item.value"
                                                    :label="item.text"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </v-col>
                                        <v-col cols="3" md="2" sm="3" xs="3">
                                            <el-select v-model="item.sourceType" filterable
                                                       placeholder="请选择来源">
                                                <el-option
                                                    v-for="item in sourceItems"
                                                    :key="item.value"
                                                    :label="item.text"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" dark @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}
                    </v-btn>
                    <v-btn color="success" dark @click="updateStudentMsg">{{
                        $vuetify.lang.t('$vuetify.custom.class.update') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>

</template>
<style></style>
<script>

    export default {
        name: 'class-stu-update',
        model: {
            prop: 'updateClassStuDialog',
            event: 'parent-event'
        },
        props: {
            updateClassStuDialog: Boolean,
            classStuMsg: Object
        },
        mounted() {
            //查询班级所有学生
            this.initSelect()
            this.updateMsg()

        },
        watch: {
            updateClassStuDialog() {
                if (this.updateClassStuDialog)
                    this.updateMsg()
            }
        },
        data: () => ({
            overlay:false,
            formData: {
                stuName: '',
                gender: '',
                age: '',
                class: '',
                school: '同上',
                source: '',
            },
            rules: {
                required:[value => !!value || '请输入'],
                idCard: [
                    value => {
                    if(value) {
                        const pattern = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
                        return pattern.test(value) || '请输入正确的身份证'
                    }
                }],
            },
            schoolItems: [
                {text: '同上', value: ''},
            ],
            allStudentMsg: [],
            sourceItems: [
                {text: '请选择来源', value: ''},
                {text: '市场招生', value: 1},
                {text: '外包推荐', value: 2},
                {text: '青岛分公司', value: 3},
            ],
        }),
        methods: {
            initSelect() {
                //学校下拉
                this.$api.school.getSchoolSelect().then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            this.schoolItems.push({text: obj.schoolName, value: obj.id})
                        })
                    }
                })
            },
            updateMsg() {
                this.overlay = true
                this.$api.student.getStudentList({classId: this.classStuMsg.id,isClassEditPage:true}).then(data => {
                    if (data.data) {
                        this.allStudentMsg = data.data
                        this.allStudentMsg.forEach(val => {
                            val.specAttention = null
                            if (val.schoolId == null)
                                val.schoolId = ''
                        })
                        this.overlay = false
                    }

                })
            },
            hiddenDialog() {
                this.$emit('parent-event', false);
            },
            updateStudentMsg() {
                let sameSchool = null

                this.allStudentMsg.forEach(value => {
                    if (value.schoolId != null && value.schoolId != '') {
                        sameSchool = value.schoolId
                    } else {
                        value.schoolId = sameSchool
                    }
                })
                if (this.$refs.form.validate()) {
                    this.$api.classList.updateClassStudents(this.classStuMsg.id, JSON.stringify(this.allStudentMsg)).then(data => {
                        if (data.flag) {
                            this.$dialog.alert("修改成功");
                            this.$emit('initialize')
                            this.hiddenDialog();
                        } else {
                            this.$dialog.alert(data.msg)
                        }
                    })

                }
            }
        },
        components: {},
    }
</script>
